import {getDataLine} from "./utils_dataTables";

const $ = require('jquery');
global.$ = global.jQuery = $;
const moment = require('moment');
global.moment = moment;
const dt = require('datatables.net-bs4');
global.dt = dt;
import './polyfill'

require('datatables.net-select-dt');
require('bootstrap');
require('air-datepicker');
require('../../node_modules/air-datepicker/dist/js/i18n/datepicker.fr.js');

// BEGIN HULK
import {CallFunction} from '../../public/bundles/w3comhulk/callFunction.js';
global.CallFunction = CallFunction;

import '../../public/bundles/w3comhulk/cellAction';

import {apiRequest, updateSap, updateSapLine, reloadDisplayForm} from '../../public/bundles/w3comhulk/ajax.js';

global.apiRequest = apiRequest;
global.updateSap = updateSap;
global.updateSapLine = updateSapLine;
global.reloadDisplayForm = reloadDisplayForm;

import {countSelectedRows, goToLine, openForm, temporizeUpdate} from '../../public/bundles/w3comhulk/utils.js';

global.countSelectedRows = countSelectedRows;
global.goToLine = goToLine;
global.openForm = openForm;
global.temporizeUpdate = temporizeUpdate;
// END HULK

// BEGIN DISPLAY
import {
    provideTransporterList,
    createTransportPurchaseOrder,
    updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotes
} from './display_gestion_transport';

global.provideTransporterList = provideTransporterList;
global.createTransportPurchaseOrder = createTransportPurchaseOrder;
global.updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotes = updateSapLineAndVehicleShipDateAndCreatePurchaseDeliveryNotes;

import {
    displayFullAddress, sendInvoiceOnEmail, createQuotation, sendQuotation, printInvoice, printInvoiceOnSiteBySelection,
    printInvoiceOnSiteMultiBySelection, printInvoiceOnSiteMultiAsyncBySelection, printInvoiceOnSiteBySelection46, checkInvoicePrinting, provideQuotation,
    launchInvoicePrinting, createCreditNotes, createInvoice, postAdsDisplay,draftAdsDisplay, toggleServicePlus, runUbiflowAuto, init
} from './display_facturation';

global.printInvoiceOnSiteBySelection = printInvoiceOnSiteBySelection;
global.printInvoiceOnSiteMultiBySelection = printInvoiceOnSiteMultiBySelection;
global.printInvoiceOnSiteMultiAsyncBySelection = printInvoiceOnSiteMultiAsyncBySelection;
global.displayFullAddress = displayFullAddress;
global.printInvoice = printInvoice;
global.sendInvoiceOnEmail = sendInvoiceOnEmail;
global.launchInvoicePrinting = launchInvoicePrinting;
global.createCreditNotes = createCreditNotes;
global.createInvoice = createInvoice;
global.postAdsDisplay = postAdsDisplay;
global.draftAdsDisplay = draftAdsDisplay;
global.createQuotation = createQuotation;
global.sendQuotation = sendQuotation;
global.provideQuotation = provideQuotation;
global.printInvoiceOnSiteBySelection46 = printInvoiceOnSiteBySelection46;
global.toggleServicePlus = toggleServicePlus;
global.runUbiflowAuto = runUbiflowAuto;
global.initDisplayBilling = init;

import {createDecompte, sendDecompteOnEmail,createDecompteDraft} from './display_decompte'

global.createDecompte = createDecompte;
global.sendDecompteOnEmail = sendDecompteOnEmail;
global.createDecompteDraft = createDecompteDraft;

import {printALD, printDenonce, sendMemo} from './display_vh_stock'

global.printALD = printALD;
global.printDenonce = printDenonce;
global.sendMemo = sendMemo;

import {sendRetardTransportOnEmail} from './display_retard_transport'

global.sendRetardTransportOnEmail = sendRetardTransportOnEmail;

import {
    printAccompaniment,
    updateDayDateCG,
    submitActivitiesVHStatus,
    init as initSaveDisplayList,
    editVehicleReceivedCG,
} from './display_statuts';

global.saveDisplayList = initSaveDisplayList;
global.printAccompaniment = printAccompaniment;
global.updateDayDateCG = updateDayDateCG;
global.submitActivitiesVHStatus = submitActivitiesVHStatus;
global.editVehicleReceivedCG = editVehicleReceivedCG;

import {vehicleImportChangeSeller} from './import_vehicle';
global.vehicleImportChangeSeller = vehicleImportChangeSeller;

import {
    importListVente,
    vehicleSaleAssignment,
    vehicleSaleAssignmentFromSale,
    printPoster,
    printPj
} from './display_liste_vehicule_vente';

global.importListVente = importListVente;
global.vehicleSaleAssignment = vehicleSaleAssignment;
global.vehicleSaleAssignmentFromSale = vehicleSaleAssignmentFromSale;
global.printPoster = printPoster;
global.printPj = printPj;

import {init as initDisplaySiv, getSIV} from './display_siv';

global.initDisplaySiv = initDisplaySiv;
global.getSIV = getSIV;

import {init as initDisplayPV,createDirectAdjudication} from './display_pv';

global.initDisplayPV = initDisplayPV;
global.createDirectAdjudication = createDirectAdjudication;

import {init as initDisplayGestionParc} from './display_gestion_parc';

global.initDisplayGestionParc = initDisplayGestionParc;
// END DISPLAY

import "./display_checkbox"

import "./sale"

///////////////// Display form loader \\\\\\\\\\\\\\\\\\\

document.addEventListener('LoadDisplayForm', function (e) {
    //addLoading();
    var elements = document.getElementsByTagName('select');
    for (var i = 0; i < elements.length; i++) {
        elements[i].disabled = true;
    }
    document.getElementById('display_submit').disabled = true;
    $('#displayFormLoader').removeClass('d-none');
});

document.addEventListener('DisplayFormLoaded', function (e) {
    var elements = document.getElementsByTagName('select');
    for (var i = 0; i < elements.length; i++) {
        elements[i].disabled = false;
    }
    document.getElementById('display_submit').disabled = false;
    $('#displayFormLoader').addClass('d-none');
});

///////////////// Display logiwin/print  \\\\\\\\\\\\\\\\\\\


global.callLogiwin = function (url, params) {
    $.post(url, params, function (data) {
        if (params.mode == 'filename') {
            window.location = '/display/DSP_VH_import?U_W3C_INTF=' + params.token;
        }
    });
};

global.callLogiwinBySelection = function (obj) {

    $('#loadingModal').modal('show');
    textLoading.innerText = 'Récupération des données logiwin';

    var docEntryArr = [];

    var tokenFlux = null;

    obj.map(function (el, index) {
        docEntryArr.push(el.DocEntry);
    });
    //console.log(docEntryArr.join(','));

    const params = {
        'mode': 'ids',
        'ids': docEntryArr.join(',')
    };

    $.post(urlLogiwin, params, function (data) {
        window.location.reload();
    });

};

global.printEtiquette = function (docNum) {
    $('#Print').fadeToggle();
    $('#PrintFrame').attr('src', '/vehicle_folder/print_' + docNum + '.pdf');
};

global.printEtiquetteBySelection = function (obj) {

    $('#PrintFrame').attr('src', '/printing');
    var docNumArr = [];
    obj.map(function (el, index) {
        if (el.hasOwnProperty('DocNum')) {
            docNumArr.push(el.DocNum);
        }
    });

    if (docNumArr.length === 0) return;

    $('#Print').fadeToggle();

    $('#PrintFrame').attr('src', '/print_etiquette_' + docNumArr.join(',') + '.pdf');
};


global.printInvoiceOnSiteBySelection46 = function (obj) {
    var callFunction = new CallFunction('printInvoiceOnSiteBySelection', 'fad fa-address-card fa-3x');
    callFunction.modalBody.innerHTML = '';
    callFunction.modalFooter.innerHTML = '';

    if (!callFunction.checkRowsLength(obj, 1, callFunction)) {
        return;
    }

    var listeDV = [];
    obj.map(function (el, index) {
        if (el.DocEntryFact != '') {
            listeDV.push(el.DocEntryFact);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec une facture');
        return;
    }
    callFunction.showModal('Impression en cours...');
    callFunction.startLoading();

    $('#printInvoiceOnSiteBySelectionTextLoading').html('Impression en cours...');
    $('#printInvoiceOnSiteBySelection').modal('show');
    $('#printInvoiceOnSiteBySelectionHeader').removeClass('d-none');

    var param = {
        'listDocEntry': listeDV
    };

    $.post("/print/invoice-site46", param, function (rep) {
        $('#printInvoiceOnSiteBySelection').modal('hide');
    });
};


global.printFactureBySelection = function (rows) {
    var callFunction = new CallFunction('printFactureBySelection', 'fad fa-print fa-2x');
    if (!callFunction.checkRowsLength(rows, 1, callFunction)) {
        return;
    }
    callFunction.showModal('Impressions des factures');
    callFunction.startLoading();
    $.post("/print-modal/invoice", {data: rows.toArray()}, function (rep) {
        callFunction.stopLoading();
        callFunction.modalBody.innerHTML = rep.template;
        callFunction.addValidateBtn(() => {
            launchInvoicePrinting(rep.invoices, callFunction, 'DocEntryFact')
        });
    })
};

global.launchInvoicePrinting = function (lines, callFunction, docEntryField) {
    var printingSelectedFormat = $('input[data-checkbox-print]:checked');
    var activitiesSelectedFormat = $('input[data-checkbox-activity]:checked');

    if (printingSelectedFormat.length == 0) {
        alert('Vous devez sélectionner au moins un format d\'impression');
        return;
    }
    var listPrint = [];
    printingSelectedFormat.map((index, el) => listPrint.push($(el).val()));

    var listActivity = [];
    activitiesSelectedFormat.map((index, el) => listActivity.push($(el).val()));

    if ($('#printer').val() == '') {
        alert('Vous devez sélectionner une imprimante');
        return;
    }
    var listDocEntry = [];
    lines.map((e) => listDocEntry.push(e[docEntryField]));
    var param = {
        'listDocEntry': listDocEntry.join('|'),
        'listPrintFormat': listPrint.join('|'),
        'selectedPrinter': $('#printer').val(),
        'createActivity': listActivity

    };

    callFunction.startLoading();
    $.post("/print/invoice", param, function (rep) {
        window.location.reload();
    });
};

global.checkInvoicePrinting = function (nbPrint) {
    $.get("/print-check/invoice/" + nbPrint, function (rep) {
        if (rep.hasOwnProperty('valid')) {
            if (rep.valid) {
                var percent = (parseInt(rep.result.done, 10) * 100) / parseInt(rep.result.todo, 10);
                $('#pbInvoicePrinting').css('width', percent + '%');
            }
        }
        setTimeout(function () {
            checkInvoicePrinting(nbPrint);
        }, 1000);
    })
};

// Active popover
$(function () {
    $('[data-toggle="popover"]').popover()
});

global.printDecompteBySelection = function (obj) {
    if (obj.length == 0) {
        alert('Vous devez sélectionner au moins une ligne');
        return;
    }

    var listeDV = [];
    obj.map(function (el, index) {
        if (el.PrintDecompte != '' && listeDV.indexOf(el.PrintDecompte) == -1) {
            listeDV.push(el.PrintDecompte);
        }
    });

    if (listeDV.length == 0) {
        alert('Vous devez sélectionner au moins un véhicule avec un décompte de vente');
        return;
    }

    $('#printDecompteBySelectionTextLoading').html('Chargement du module d\'impression');
    $('#printDecompteBySelection').modal('show');
    $('#printDecompteBySelectionHeader').removeClass('d-none');


    $.post("/print-modal/purchase", {data: listeDV}, function (rep) {
        $('#printDecompteBySelectionHeader').addClass('d-none');
        $('#printDecompteBySelectionBody').removeClass('d-none');
        $('#printDecompteBySelectionBody').html(rep);
    })
};

global.launchGenericPrinting = function () {
    if ($('#printer').val() == '') {
        alert('Vous devez sélectionner une imprimante');
        return;
    }

    var param = {
        'listPrinting': $('#listPrinting').val(),
        'selectedPrinter': $('#printer').val()
    };

    $('#btnLaunchGenericPrinting').addClass('d-none');
    $('#waitingGenericPrinting').removeClass('d-none');

    $.post("/print/generic", param, function (rep) {
        $('#btnLaunchGenericPrinting').removeClass('d-none');
        $('#waitingGenericPrinting').addClass('d-none');
        $('#printGenericBySelection').modal('hide');
    });
};

global.PurchaseSummary = function () {
    var html = '<table class="table table-striped">' +
        '<tr><td>Nombre de VH</td><td class="text-right" id="summaryNbv"></td></tr>' +
        '<tr><td>Adjudication</td><td class="text-right" id="summaryAdj"></td></tr>' +
        '<tr><td>Réserve</td><td class="text-right" id="summaryRes"></td></tr>' +
        //'<tr><td>Montant à payer</td><td class="text-right" id="summarySol"></td></tr>' +
        '</table>' +
        '<div class="row border-top pt-3"><div class="col-2"><label class="checkbox-label" style="margin-right: 0"><input type="checkbox" checked id="onlyFiltered" />' +
        '<span class="checkbox-custom rectangular"></span></label></div><div class="col-10"><label class="form-check-label" ' +
        'for="onlyFiltered" style="line-height: 23px;">Restreindre aux véhicules filtrés</label></div></div>';

    $('#PurchaseSummary').modal('show');
    $('#PurchaseSummaryHeader').html('<h3><i class="fad fa-chart-pie mr-2"></i>Tableau récapitulatif</h3>');
    $('#PurchaseSummaryBody').removeClass('d-none');
    $('#PurchaseSummaryBody').html(html);

    toggleSummary();
    $('#onlyFiltered').click(() => toggleSummary());
};

global.toggleSummary = function () {
    var rows;
    if ($('#onlyFiltered').prop('checked')) {
        rows = $('#dataTable').DataTable().rows({filter: 'applied'}).data();
    } else {
        rows = $('#dataTable').DataTable().rows().data();
    }

    var totalAdj = 0;
    var totalReserve = 0;
    //var totalSolde = 0;

    rows.map(function (row, index) {
        totalAdj += parseInt(row.U_W3C_PXAJ, 10);
        totalReserve += parseInt(row.U_W3C_PXRV, 10);
        //if(row.SoldeFacture != ''){
        //    totalSolde += parseInt(row.SoldeFacture,10);
        //}
    });
    $('#summaryAdj').html(totalAdj.toLocaleString('fr-FR') + ' €');
    $('#summaryRes').html(totalReserve.toLocaleString('fr-FR') + ' €');
    //$('#summarySol').html(totalSolde.toLocaleString('fr-FR') + ' €');
    $('#summaryNbv').html(rows.length);
};

global.cancelIncomingPayment = function (obj) {
    if (obj.length == 0) {
        alert('Vous n\'avez pas sélectionné d\'encaissement');
        return;
    } else if (obj.length > 1) {
        alert('Vous ne devez sélectionner qu\'une ligne à la fois.');
        return;
    }

    $('#cancelIncomingPaymentTextLoading').html('Chargement du module de suppression d\'encaissement');
    $('#cancelIncomingPayment').modal('show');
    $('#cancelIncomingPayment .icon-loading').removeClass('d-none');
    $('#cancelIncomingPaymentHeader').removeClass('d-none');

    $.post("/incoming_payment/display", {'ip': obj[0]}, function (rep) {
        $('#cancelIncomingPaymentHeader').addClass('d-none');
        $('#cancelIncomingPaymentBody').removeClass('d-none');
        $('#cancelIncomingPaymentBody').html(rep);
        $('#cancelDate').datepicker({language: 'fr', autoClose: true});
    })
};

global.launchCancelIncomingPayment = function () {
    if (!$('#cancelCheck').prop('checked')) {
        alert('Veuillez confirmer la suppression');
        return;
    }

    $('#btnCancelIncomingPayment').addClass('d-none');
    $('#waitingCancelIncomingPayment').removeClass('d-none');
    $('#errorCancelIncomingPayment').addClass('d-none');


    let param = {
        docEntry: $('#DocEntry').val(),
        cancelDate: $('#cancelDate').val(),
        bankAccount: $('#bankAccount').val(),
        cancelLabel: $('#cancelLabel').val()
    };

    $.post("/incoming_payment/cancel", param, function (rep) {
        if (!rep.valid) {
            $('#errorCancelIncomingPayment').html(rep.error);
            $('#errorCancelIncomingPayment').removeClass('d-none');
            $('#btnCancelIncomingPayment').removeClass('d-none');
            $('#waitingCancelIncomingPayment').addClass('d-none');
        } else {
            window.location.reload();
        }
    });
};



// WEBPACK FOOTER //
// ./assets/js/display.js